<template>
    <v-flex xs12 lg3 ma-1>
        <v-card>
            <v-card-text>
               
                <v-layout column>
                    <v-btn disabled>View and Print/Email Up-Front Invoices</v-btn>
                </v-layout>
                
            </v-card-text>
        </v-card>
    </v-flex>
</template>

<script>
    /**
     * Display buttons linking through to accounts invoice viewing and printing pages
     */
    export default {
        props:[],

        data: function() {
            return {
            }
        },

        /**
         * Perform the following actions on startup
         */
        mounted: function(){},

        methods: {},

        computed: {}
    }
</script>
